import { Layout } from 'antd';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { Sidebar } from './Sidebar';

const MOBILE_BREAKPOINT = 768;
const COLLAPSED_KEY = 'hibinoe.sidebar.collapsed';

export const LayoutComponent: React.FC = () => {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem(COLLAPSED_KEY) === '1',
  );
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    localStorage.setItem(COLLAPSED_KEY, collapsed ? '1' : '0');
  }, [collapsed]);

  return (
    <Layout style={{ minHeight: '100vh', background: 'var(--color-surface)' }}>
      <Sidebar
        collapsed={collapsed}
        onCollapsedChange={setCollapsed}
        mobileOpen={mobileOpen}
        onMobileOpenChange={setMobileOpen}
      />
      <Layout style={{ background: 'var(--color-surface)' }}>
        <AppHeader
          collapsed={collapsed}
          onToggleCollapsed={() => setCollapsed((c) => !c)}
          isMobile={isMobile}
          onOpenMobile={() => setMobileOpen(true)}
        />
        <Layout.Content className='px-lg py-md'>
          {/*
            画面の横幅をここで揃える。大半のページは同じ指定を各自で持っていたが、
            持たないページ（変化のたより・あゆみ・プロンプト等）だけが幅いっぱいに
            広がっていた。各ページに書き足すとまた抜けるので、レイアウトで1か所にする。
            `max-w-[1280px]`（固定幅）ではなく `max-w-[1280px]`（上限）なのは、
            サイドバー240px と余白32px を引いた残りが 1280px に満たない画面幅
            （1280〜1551px。1366/1440/1512 など）で横スクロールが出るため。
            `h-full` は、ページ側の `h-full` が解決する相手を今までと同じ（Content の高さ）に
            保つために必要。外すと高さが auto に化ける。
          */}
          <div className='mx-auto w-full max-w-[1280px] h-full'>
            <Outlet />
          </div>
        </Layout.Content>
      </Layout>
    </Layout>
  );
};
